import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { Utils } from 'src/app/core/utils';
import { CustomerService } from 'src/app/core/services/customer.service';
import { AppData } from 'src/app/app.data';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit {
  public settings: Settings;
  public apiEndPoint: string =  Utils.getApiEndPoint(); // environment.APIEndpoint;
  public canSelectNewCustomerMenuItem: boolean;

  constructor(
    private appDate: AppData,
    public translate: TranslateService,
    public appSettings: AppSettings,
    public appData: AppData,
    public router: Router,
    public authService: AuthenticateService,
    private route: ActivatedRoute,
    private customerService: CustomerService) {
      this.settings = appSettings.settings;
    }

    ngOnInit() {

      // the menuItem "CreateNewPatient" is disabled for unAuthorized users and if user is already in creation/business Selection screen
      const isInSelectBusinessOrCreatePatient = ['/select-business', '/new-customer'].includes(this.router.url);
      this.canSelectNewCustomerMenuItem = (this.authService.claims.CanAddNewPatient || false) && !isInSelectBusinessOrCreatePatient;
  }

  logout(event) {
    this.router.navigate(['/login' ]);
  }

  onNewCustomer(event) {

    this.customerService.getUserBusiness().subscribe(result => {
      const data = result.Data;
      this.appData.newCustomerBusinessList = data.businessList || [];

      if (data.shouldSelectBusiness) {
        // select business for additional fields
        this.appDate.newCustomerBackUrl = this.router.url;
        this.router.navigate(['/select-business']);
      } else {
        // if no change in additional fields selected the first businessID
        const businessID = data.businessList && +data.businessList[0].Value;
        this.appData.newCustomerBusinessID = businessID;
        this.router.navigate(['/new-customer']);
      }

    });
  }
}
